import Template from '../template/player.ejs';
import Icons from './icons';
export default function (options) {
    options.container.innerHTML = Template({
        options: options.options,
        audio: options.audio,
        icons: Icons
    });
};